<template>
	<v-container fluid >
		<v-layout row wrap>
			<v-flex xs12>
				<v-card class="elevation-0 background-transparent">
					<DataTable
						:excel="true"
						:headers="tourProfitTable.headers"
						:items="tourProfitTable.items"
						:total="tourProfitTable.total"
						@excel="excelExport"
						@reload="reloadData"
					>
						<template #row="props">
							<tr :key="JSON.stringify(props.item)" :class="{'tour-cancelled-row': (props.item.cancelled == 1), 'cursor-pointer': true, 'cancelled-row': (props.item.cancelled_by != null)}"
								@contextmenu.prevent="editClick(props.item.id, true)">
								<td @click="editClick(props.item.id, false)">{{ props.item.id }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.name }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.category }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.destination }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.start_date_display }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.guests }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.nights }}</td>
								<td class="text-xs-right" @click="editClick(props.item.id, false)">{{ props.item.total_income_display }}</td>
								<td class="text-xs-right" @click="editClick(props.item.id, false)">{{ props.item.total_cost_display }}</td>
								<td class="text-xs-right" @click="editClick(props.item.id, false)">{{ props.item.total_profit_display }}</td>
								<td class="text-xs-right" @click="editClick(props.item.id, false)">{{ props.item.total_profit_percentage_display }}</td>
								<td>
									<v-tooltip bottom>
										<v-btn @click="editClick(props.item.id, true)" icon slot="activator">
											<v-icon small>fa-external-link-alt</v-icon>
										</v-btn>
										<span>{{$t('tooltips.openInNewTab')}}</span>
									</v-tooltip>
								</td>
							</tr>
						</template>
						<template #footer>
							<tr>
								<td colspan="7"></td>
								<td class="text-xs-right">{{tourProfitTable.sumIncome}}</td>
								<td class="text-xs-right">{{tourProfitTable.sumCost}}</td>
								<td class="text-xs-right">{{tourProfitTable.sumProfit}}</td>
								<td colspan="2"></td>
							</tr>
						</template>
					</DataTable>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
	import DataTable from "./trinkets/DataTable";
	import Payment from "./modals/Payment";

	export default {
		name: "TourProfit",
		components: {DataTable, Payment},
		data: function () {
			return {
				tourProfitTable: {
					headers: [
						{text: this.$t('fields.id'), value: 'id', type: 'string', searchable: 'hidden'},
						{text: this.$t('fields.tourName'), value: 'name', type: 'string', searchable: 'hidden'},
						{text: this.$t('fields.tourCategory'), value: 'tour_category_id', type: 'dropdown|tour-categories', searchable: 'hidden'},
						{text: this.$t('fields.destination'), value: 'destination_id', type: 'dropdown|destinations', searchable: 'hidden'},
						{
							text: this.$t('fields.startDate'),
							value: 'start_date',
							type: 'date_range',
							searchable: 'hidden'
						},
						{text: this.$t('fields.guests'), value: 'guests', type: 'price_range', searchable: 'hidden'},
						{text: this.$t('fields.nights'), value: 'nights', type: 'price_range', searchable: 'hidden'},
						{text: this.$t('fields.totalTourIncome'), value: 'total_income', type: 'price_range', searchable: 'hidden', class: 'text-xs-right'},
						{text: this.$t('fields.totalTourCost'), value: 'total_cost', type: 'price_range', searchable: 'hidden', class: 'text-xs-right'},
						{text: this.$t('fields.totalGrossProfit'), value: 'total_profit', type: 'price_range', searchable: 'hidden', class: 'text-xs-right'},
						{text: this.$t('fields.totalGrossProfitPercentage'), value: 'total_profit_percentage', type: 'price_range', searchable: 'hidden', class: 'text-xs-right'},
						{
							text: '',
							value: 'actions',
							type: '',
							sortable: false,
							align: "right",
							width: "100px",
							searchable: false
						}
					],
					items: [],
					total: 0,
					lastRequest: null,
					sumIncome: 0,
					sumCost: 0,
					sumProfit: 0
				}
			}
		},
		methods: {
			editClick(id, newTab = false) {
				if (!newTab) {
					this.$router.push('/tours/' + id)
				} else {
					let routeData = this.$router.resolve('/tours/' + id);
					window.open(routeData.href, '_blank');
				}
			},
			reloadData(request) {
				this.tourProfitTable.lastRequest = request;
				let vm = this;
				this.$APICall('get', 'tours/profit', request, (data, success) => {
					if (success) {
						vm.markedRecords = [];
						vm.tourProfitTable.items = data.items;
						vm.tourProfitTable.total = data.total;
						vm.tourProfitTable.sumCost = data.sum_cost_display;
						vm.tourProfitTable.sumIncome = data.sum_income_display;
						vm.tourProfitTable.sumProfit = data.sum_profit_display;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				}, false);
			},
			excelExport() {
				let excelRequest = JSON.parse(JSON.stringify(this.tourProfitTable.lastRequest));
				excelRequest.pagination.rowsPerPage = 999999999;
				excelRequest.pagination.page = 1;

				let vm = this;
				this.$APICall('get', 'tours/profit', excelRequest, (data, success) => {
					if (success) {
						vm.$APICall('post', 'excel/tours-profit', data.items, (data, success) => {
							window.open(data.link);
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				}, false);
			}
		},
		mounted() {
			if (!this.$myStore.state.loggedIn) {
				this.$router.replace('login');
			}
			this.$setSubMenu('Reporting');
			this.$myStore.commit('setBreadcrumbs', [
				{text: this.$t('modules.tourProfit'), href: '/#/tour-profit', disabled: true}
			]);
		}
	}
</script>

<style scoped>
	.cancelled-row {
		color: #ff0000;
	}
	.tour-cancelled-row td {
		text-decoration: line-through;
	}

	.tour-cancelled-row td:last-child {
		text-decoration: none;
	}
</style>
